module.exports = __webpack_public_path__ + "static/guardian-ce9c7d9691832bb2f68590783a010c53.jpg";